import { getCustomUserAgent } from "../../../common/customUserAgent";
import { getUuidAndSession } from "../../../common/localStorage";

export interface IDemFile {
  id: number;
  mime: string;
  name: string;
  size: number;
  url: string;
  base64?: string;
}

export interface IQuerySetDemRate {
  demandId: number;
  rate: number;
  comment: string;
}

export interface IQuerySetDemRateResult {
  loaded: boolean;
  fail: boolean;
  msg: string;
}

export const querySetDemRate = (
  demid: number,
  rate: number,
  comment: string,
  setDemRateRes: React.Dispatch<React.SetStateAction<IQuerySetDemRateResult>>
) => {
  fetch("https://izba.kras-abs.ru/api/v3/demand/setDemandRating", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      demandId: demid + "",
      rating: rate + "",
      ratingComment: comment + "",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      console.log("groups:", res);
      // const ret = {
      //   loaded: true,
      //   fail: false,
      //   msg: JSON.stringify(res),
      // } as IQuerySetDemRateResult;
      // console.log("setDemandRating22:", ret);
      // setDemRateRes(ret);
    })
    .catch((err) => {
      console.log("err_c:", err);
      // const ret = {
      //   loaded: true,
      //   fail: true,
      //   msg: err.message,
      // } as IQuerySetDemRateResult;
      // console.log("setDemandRating33:", ret);
      // setDemRateRes(ret);
    });
};
